import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Company, CompanyEnum } from '../../models/company.model';
import { Note } from '../../models/types';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'lx-price-lists-portal-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss', './print-notes.component.scss'],
})
export class NotesComponent {
  @Input() notes: Note[] = [];
  @Input() company: Company = CompanyEnum.KIL;
  @Input() notationMarks: Record<string, string> | undefined;
  companyEnum = CompanyEnum;
}
